module.exports = __webpack_public_path__ + "images/img_4_1-a41a8685aa.png";